function Graph() {
    this.MasterNode = [];
    this.Nodes = [];
    this.ConnectionReasons = [];
    this.Associations = [];
    this.Connections = [];
    this.Collections = [];
}
if (typeof exports !== 'undefined') {
    module.exports = Graph;
}